import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "textarea"]

  toggleOtherTextareaRequired(event) {
    if (this.hasTextareaTarget) {
      if (event.target.value === "other") {
        this.textareaTarget.required = true
      } else {
        this.textareaTarget.required = false
      }
    }
  }

  handleSubmit(event) {
    if (!this.checkFormValidity()) {
      event.preventDefault()

      if (typeof this.formTarget.reportValidity === "function") {
        this.formTarget.reportValidity()
      } else {
        const firstInvalidField = this.formTarget.querySelector(":invalid")
        if (firstInvalidField && typeof firstInvalidField.reportValidity === "function") {
          firstInvalidField.reportValidity()
        } else {
          alert("Please fill out all required fields correctly.")
        }
      }
      return
    }
  }

  checkFormValidity() {
    let isValid = true
    const reasonSelected = this.formTarget.querySelector("input[type=radio]:checked")

    if (!reasonSelected) {
      isValid = false
    } else if (reasonSelected.value === "other") {
      if (!this.hasTextareaTarget || this.textareaTarget.value.trim() === "") {
        if (this.hasTextareaTarget) {
          this.textareaTarget.required = true
        }
        isValid = false
      } else {
        if (this.hasTextareaTarget) {
          this.textareaTarget.required = false
        }
      }
    } else {
      if (this.hasTextareaTarget) {
        this.textareaTarget.required = false
      }
    }

    if (isValid && typeof this.formTarget.checkValidity === "function") {
      if (!this.formTarget.checkValidity()) {
        isValid = false
      }
    }
    return isValid
  }
}